import { COLOR_SWAP_TRANSITION_DURATION } from '../../constants';

import { css, createGlobalStyle } from 'styled-components';

export const reset = css`
  /*
    Josh's Custom CSS Reset
    https://www.joshwcomeau.com/css/global-styles/
  */

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
    line-height: 1.5;
    line-height: calc(1em + 0.725rem);
    -webkit-font-smoothing: antialiased;
  }

  html,
  body {
    min-height: 100vh;
    position: relative;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }

  ul {
    padding: 0;
  }

  #__next {
    isolation: isolate;
  }

  a:focus {
    // TODO: change this
    outline: 5px auto ${({ theme }) => theme.colors.PRIMARY};
  }

  body,
  input,
  button,
  select,
  option {
    // TODO: change this
    font-family: var(--font-family);
    font-weight: var(--font-weight-light);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    // TODO: change this
    font-weight: var(--font-weight-bold);
  }

  code {
    font-size: 0.95em;
  }
`;

const GlobalStyle = createGlobalStyle`${reset}

  @media (orientation: landscape) {
    ::-webkit-scrollbar {
      width: 12px;
      transition: background 350ms ease 0s;
      background-color:  ${({ theme }) => theme.colors.GRAY_100};
    }
    ::-webkit-scrollbar-track {
      border-radius: 3px;
      transition: background 350ms ease 0s;
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      transition: background 350ms ease 0s;
      background-color: ${({ theme }) => theme.colors.GRAY_700};
      border: 2px solid ${({ theme }) => theme.colors.GRAY_100};
    }
  }

  input:focus,
    select:focus,
    button:focus,
    textarea:focus,
    input[type=button]:focus,
    input.form-control:focus {
      box-shadow: none;
      -moz-box-shadow: none;
      outline:none !important;
      -webkit-box-shadow: none;
      outline-width: 0 !important;
      color: ${({ theme }) => theme.colors.TEXT};
    }

    /* Change autocomplete styles in WebKit */
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      transition: background-color 5000s ease-in-out 0s;
      -webkit-box-shadow: 0 0 0px 1000px transparent inset;
      -webkit-text-fill-color: ${({ theme }) => theme.colors.TEXT};
    }


  /* CSS Variables */
  :root {
    --font-weight-bold: 600;
    --font-weight-light: 200;
    --font-weight-medium: 500;
    --font-weight-regular: 300;

    --font-family: 'Wotfard', Futura, -apple-system, sans-serif;
    --font-family-mono: 'League Mono', 'Fira Mono', monospace;
    --font-family-spicy: 'Sriracha', 'Wotfard', Futura, -apple-system, sans-serif;
    --font-family-cal: 'Digital7'

    /* HACK:
      Reach UI tests for loaded styles, but I'm providing my own.
      This is to avoid a noisy warning in dev.
    */
   --reach-dialog: 1;
  }

  body {
    color: ${({ theme }) => theme.colors.TEXT};
    background: ${({ theme }) => theme.colors.BACKGROUND};
    transition: ${() =>
      `color ${COLOR_SWAP_TRANSITION_DURATION}ms, background ${COLOR_SWAP_TRANSITION_DURATION}ms`};
  }
`;

export default GlobalStyle;
